export const REI_ADDR = "0x3e9d9124596af6d8faaefc9b3e07b3ce397d34f7";
export const REI_LOCK = "0xD02b2eBB830B4C2CD701bD10003789a8F5A11631";
export const REI_ETH_ADDR = '0x7afBEb90B3f15d378E59F741dCA38f4b07653B9c';
export const MULTICALL_ADDR = '0xeefBa1e63905eF1D7ACbA5a8513c70307C1cE441';
export const DIVIDEND_ADDR = '0x1921afd75ffe25a4095f1036f73c5de1ba202f3e';